import React from 'react';
import ReactModal from 'react-modal';
import {browserVersion, isMobile } from "react-device-detect";

import Product from './Product';
import { MobileTopbar } from '../../../components/layout';

const ProductPreviewView = ({
  renderedForId,
  user,
  product,
  inModal,
  onClose,
  onSelect,
  requestType,
  onProductRefresh,
}) => {
  if (!inModal) {
    return (
      <Product {...{ user, product, onSelect, onProductRefresh }} />
    );
  }

  if (!product?.id || (renderedForId && renderedForId !== product?.id)) {
    return null;
  }

  return (
    <ReactModal
      {...{
        isOpen: product !== null,
        onRequestClose: onClose,
        className:`product-preview-modal rc-product-modal ${(browserVersion<15 && !isMobile )? 'old-mac-product-preview-modal':''}`,
        overlayClassName: 'rc-product-modal-overlay',
      }}
    >
      {/* The modal is a portal on <body>, so it sits outside `.rc-app-shell__content`
          where AppShell renders the shared mobile topbar — and on mobile this modal
          covers the whole viewport, hiding it. Render our own inside so the
          hamburger / profile / notification row is reachable here too. It hides
          itself on desktop (see `.rc-mobile-topbar` in rc-ui.scss). */}
      <MobileTopbar />
      <Product {...{ renderedForId, user, product, onSelect, onClose, requestType, onProductRefresh }} />
    </ReactModal>
  );
};

export default ProductPreviewView;
